import { beginCheckout } from 'store/checkout/checkoutActions';
import { createBeginCheckoutEvent } from '../eventCreators';
import { createBeginCheckoutEventPayload } from '../dataHelpers/createBeginCheckoutEventPayload';

const emitBeginCheckout = ({ payload }) => {
  const beginCheckoutEvent = createBeginCheckoutEvent(
    createBeginCheckoutEventPayload({
      ctaMessage: payload.ctaMessage,
      ctaMessageCategory: payload.ctaMessageCategory,
      quote: payload.quote,
      payments: payload.payments,
      pointsConversion: payload.pointsConversion,
      isRebooked: payload.isRebooked,
    }),
  );

  return beginCheckoutEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [beginCheckout]: emitBeginCheckout };
